export default __webpack_public_path__ + "static/media/PAFI Ringkasan Risalah Minutes Summary GMS 2026.8e832a43.pdf";